// Auto-generated by scripts/generate-registry.mjs from packages/modules/waves_ambient_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const waves_ambient_lamp: ModuleSchema = {
  "id": "waves_ambient_lamp",
  "uniqueId": "B3D_2XB0M",
  "createdAt": "2026-10-08T14:25:52.430Z",
  "updatedAt": "2026-10-14T00:50:01.328Z",
  "label": "Waves",
  "description": "Tiered sculptural table light with a softly ribbed shade seated on a reusable E27 base shell.",
  "category": "lighting",
  "tags": [
    "lamp",
    "waves",
    "ambient",
    "e27",
    "shade"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Base Outer Diameter",
      "min": 80,
      "max": 160,
      "step": 1,
      "default": 120,
      "unit": "mm"
    },
    {
      "key": "baseHeight",
      "label": "Base Height",
      "min": 60,
      "max": 140,
      "step": 1,
      "default": 65,
      "unit": "mm"
    },
    {
      "key": "baseCornerR",
      "label": "Base Edge Radius",
      "min": 1,
      "max": 8,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "shadeMaxDia",
      "label": "Shade Maximum Diameter",
      "min": 120,
      "max": 200,
      "step": 1,
      "default": 150,
      "unit": "mm"
    },
    {
      "key": "shadeMinDia",
      "label": "Shade Trough Diameter",
      "min": 110,
      "max": 180,
      "step": 1,
      "default": 136,
      "unit": "mm"
    },
    {
      "key": "shadeHeight",
      "label": "Shade Height",
      "min": 80,
      "max": 240,
      "step": 1,
      "default": 150,
      "unit": "mm"
    },
    {
      "key": "shadeFuzzy",
      "label": "Shade Fuzzy Skin (0=Off, 1=On)",
      "min": 0,
      "max": 1,
      "step": 1,
      "default": 0,
      "integerOnly": true
    },
    {
      "key": "waveCount",
      "label": "Wave Tiers",
      "min": 2,
      "max": 6,
      "step": 1,
      "default": 4
    },
    {
      "key": "wallThickness",
      "label": "Shade Wall Thickness",
      "min": 0.8,
      "max": 3,
      "step": 0.1,
      "default": 0.8,
      "unit": "mm",
      "integerOnly": false
    },
    {
      "key": "mountingHoleDia",
      "label": "Mounting Hole Diameter",
      "min": 40,
      "max": 44,
      "step": 0.1,
      "default": 41.5,
      "unit": "mm"
    },
    {
      "key": "shelfThickness",
      "label": "Mounting Shelf Thickness",
      "min": 2,
      "max": 5,
      "step": 0.1,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "innerFilletRadius",
      "label": "Shade Inner Fillet Radius",
      "min": 0,
      "max": 16,
      "step": 0.5,
      "default": 3,
      "unit": "mm",
      "integerOnly": false
    },
    {
      "key": "lightVentCount",
      "label": "Semicircular Light Vents",
      "min": 0,
      "max": 24,
      "step": 1,
      "default": 8,
      "integerOnly": true
    },
    {
      "key": "lightVentDiameter",
      "label": "Light Vent Diameter",
      "min": 0,
      "max": 40,
      "step": 0.5,
      "default": 26,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "waves_base",
      "label": "Waves Base",
      "default": "#854D0E",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "waves_screws",
      "label": "Waves Base - 4 Screws",
      "default": "#64748B",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "waves_shade",
      "label": "Waves Shade",
      "default": "#F8FAFC",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "waves_base_obj",
      "label": "Waves Base",
      "name": "Waves Base",
      "color": "#854D0E",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "waves_base",
          "label": "Waves Base",
          "name": "Waves Base",
          "groupId": 0,
          "colorKey": "waves_base",
          "defaultColor": "#854D0E",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "waves_screws_obj",
      "label": "Waves Base Screws",
      "name": "Waves Base Screws",
      "color": "#64748B",
      "assembled_z_offset": 0,
      "exploded_z_offset": -12,
      "parts": [
        {
          "id": "waves_screws",
          "label": "Waves Base - 4 Screws",
          "name": "Waves Base - 4 Screws",
          "groupId": 2,
          "colorKey": "waves_screws",
          "defaultColor": "#64748B",
          "assembled_z_offset": 0,
          "exploded_z_offset": -12,
          "export_stl": true
        }
      ]
    },
    {
      "id": "waves_shade_obj",
      "label": "Waves Shade",
      "name": "Waves Shade",
      "color": "#F8FAFC",
      "assembled_z_offset": 0,
      "exploded_z_offset": 45,
      "parts": [
        {
          "id": "waves_shade",
          "label": "Waves Shade",
          "name": "Waves Shade",
          "groupId": 1,
          "colorKey": "waves_shade",
          "defaultColor": "#F8FAFC",
          "assembled_z_offset": 0,
          "exploded_z_offset": 45,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "assembly",
      "label": "Full Assembly",
      "targetGroupId": -1,
      "default": true
    },
    {
      "id": "base",
      "label": "Base Only",
      "targetGroupId": 0
    },
    {
      "id": "screws",
      "label": "Screws Only",
      "targetGroupId": 2
    },
    {
      "id": "shade",
      "label": "Shade Only",
      "targetGroupId": 1
    }
  ]
};
